export default "__VITE_ASSET__BAl55yGr__"